/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Venueflyerheadline2Inputs */

const en_venueflyerheadline2 = /** @type {(inputs: Venueflyerheadline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something going on here? Open the Live Room.`)
};

const de_venueflyerheadline2 = /** @type {(inputs: Venueflyerheadline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier ist was los? Mach den Live Room auf.`)
};

/**
* | output |
* | --- |
* | "Something going on here? Open the Live Room." |
*
* @param {Venueflyerheadline2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const venueflyerheadline2 = /** @type {((inputs?: Venueflyerheadline2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Venueflyerheadline2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_venueflyerheadline2(inputs)
	return de_venueflyerheadline2(inputs)
});
export { venueflyerheadline2 as "venueFlyerHeadline" }